import React, { useRef } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import { useSectionViewTracking } from '../CustomHook/useSectionViewTracking';
import { LanguageLandingPage } from '../../../global-interfaces';

import s from './Blog.scss';
import { LanguageLandingPageBlogType } from '../../../../../api/public/static-pages-api';
import { LocalizedLink } from '../../../../../shared/public/LocalizedLink/LocalizedLink';
import { Container } from '../../../../../symphony';

interface IWhyLearnProps {
	data: LanguageLandingPageBlogType;
}

export function Blog({ data }: IWhyLearnProps): JSX.Element {
	useStyles(s);
	const element = useRef<HTMLElement>(null);

	useSectionViewTracking({
		ref: element,
		sectionName: LanguageLandingPage.Blog,
		sectionTitle: data.title,
	});

	const host = Container.take('global', 'host');

	return (
		<section
			className="sl-language__blog"
			ref={element}
			sl-test-data="cmpLanguageBlog"
		>
			<h2 className="sl-language__blog__title">{data.title}</h2>
			<div className="sl-language__blog__container">
				{data.blogItems.map((item) => (
					<div className="sl-language__blog__item" key={item.id}>
						<LocalizedLink
							to={`${host}/blog/${item.id}`}
							target="_blank"
						>
							<img
								src={item.imgUrl}
								alt={item.title}
								className="sl-language__blog__item__pic"
							/>
						</LocalizedLink>
						<LocalizedLink
							to={`${host}/blog/${item.id}`}
							target="_blank"
						>
							<h3 className="sl-language__blog__item__title">
								{item.title}
							</h3>
						</LocalizedLink>
						<p className="sl-language__blog__item__description">
							{item.text.length > 136
								? `${item.text.substring(0, 133)}...`
								: item.text}
						</p>
						<LocalizedLink
							to={`${host}/blog/${item.id}`}
							target="_blank"
							className="sl-language__blog__item__read-more-url"
						>
							{item.linkText}
						</LocalizedLink>
					</div>
				))}
			</div>
		</section>
	);
}
